import apiClient from "../ApiClient";

const attachmentService = () => {
  const { request } = apiClient();

  const uploadDraftAttachments = async (files) => {
    try {
      const formData = new FormData();
      files.forEach(file => {
        formData.append('files', file);
      });
      return await request("POST", "/attachments/upload-draft-attachments", formData, {
        headers: {
        }
      });
    } catch (error) {
      throw error;
    }
  };

  const deleteDraftAttachments = async (attachmentsInDraftList) => {
    try {
      return await request("POST", "/attachments/delete-draft-attachments", attachmentsInDraftList);
    } catch (error) {
      throw error;
    }
  };

  const deleteAttachments = async (attachmentsList) => {
    try {
      return await request("POST", "/attachments/delete-attachments", attachmentsList);
    } catch (error) {
      throw error;
    }
  };

  const downloadAttachment = async (file) => {
    try {
      var urlPath = `/attachments/download-attachment/${file.id}?fileName=${file.fileName}&s3FilePath=${file.s3FilePath}`;      
      return await request("GET", urlPath, null, {}, false, "blob");
    } catch (error) {  
      console.log(error);    
      throw error;
    }
  };

  return {
    uploadDraftAttachments,
    deleteDraftAttachments,
    deleteAttachments,
    downloadAttachment,
  };
};
export default attachmentService;
